import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  tags: [],
  nclexAreas: []
}

const getters = {
  tags (state) {
    return state.tags
  },
  nclexAreas (state) {
    return state.nclexAreas
  }
}

const mutations = {
  setTags (state, payload) {
    state.tags = payload
  },
  setNclexAreas (state, payload) {
    state.nclexAreas = payload
  }
}

const actions = {
  loadTags: (store) => new Promise((resolve, reject) => {
    firebase.database().ref('constants/tags').on('value', (snapshot) => {
      const tags = snapshot.val() ? [...snapshot.val()] : []
      store.commit('setTags', tags)
      resolve()
    })
  }),
  loadNclexAreas: (store) => new Promise((resolve, reject) => {
    firebase.database().ref('constants/nclexAreas').on('value', snapshot => {
      const nclexAreas = snapshot.val() ? [...snapshot.val()] : []
      store.commit('setNclexAreas', nclexAreas)
      resolve()
    })
  }),
  saveTags: (store, payload) => new Promise((resolve, reject) => {
    const tags = [...payload]
    firebase.database().ref('constants/tags').set(tags).then((t) => {
      resolve(t)
    })
  }),
  saveNclexAreas: (store, payload) => new Promise((resolve, reject) => {
    const nclexAreas = [...payload]
    firebase.database().ref('constants/nclexAreas').set(nclexAreas).then(a => {
      resolve(a)
    })
  }),
  resetTags (store) {
    store.commit('setTags', [])
    store.commit('setNclexAreas', [])
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tags.js